import React from "react";
import classes from "./Contacts.module.css";
import {NAIL_SHOP_INFO} from "../../utils/Const";
import {images} from "../../assets/img";
import BookNowBtn from "../BookNowBtn";

const Contacts = (props) => {
    return (
        <div ref={props?.contactsRef} className={classes.contacts}>
            <div className={classes.contactsContainer}>
                <h1>{"Contact Us"}</h1>

                <a href={`tel:${NAIL_SHOP_INFO.tel}`}>{`Hotline: ${NAIL_SHOP_INFO.phone}\n\n`}</a>
                <a href={`mailto:${NAIL_SHOP_INFO.email}`}>{`Email: ${NAIL_SHOP_INFO.email}`}</a>

                <div>
                    <a
                        target={"_blank"}
                        href={NAIL_SHOP_INFO.instagram}
                        rel="noreferrer">
                        <img
                            className={classes.contactsContainerImg}
                            alt={"insta"}
                            src={images.instaIcon}
                        />
                    </a>
                    <a target={"_blank"} href={NAIL_SHOP_INFO.facebook} rel="noreferrer">
                        <img className={classes.contactsContainerImg} alt={"facebook"} src={images.fbIcon}/>
                    </a>
                </div>
                <BookNowBtn isShowArrow={false} style={classes.bookNowBtn}/>
            </div>

            <iframe
                title="google-map"
                className={classes.iframe}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.9186195532957!2d-0.47368099999999985!3d51.514708999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48766f59b7359997%3A0x2bee04d77d891026!2sNail%20Art%20Yiewsley!5e0!3m2!1sen!2s!4v1762253809527!5m2!1sen!2s"
                allowFullScreen="" loading="lazy"
                referrerPolicy="no-referrer-when-downgrade">
            </iframe>
        </div>
    );
};

export default Contacts
